import { motion } from "framer-motion";
import { PartyPopper, ChevronRight, RefreshCw } from "lucide-react";

import { Card } from "@/components/ui/card";
import { cn } from "@/lib/utils";

// FIN-1 — AssinaturasResumoCard
// Detecção real fica pra FIN-4. Por ora: empty state + footer "Ver todas
// →" pra tab Assinaturas (que mostra ComingSoon).

const fmtBRL = (v) => Number(v ?? 0).toLocaleString("pt-BR", {
  style: "currency", currency: "BRL",
});

export default function AssinaturasResumoCard({ onSeeAll }) {
  // Mock até FIN-4: 0 assinaturas detectadas, custo 0.
  const count = 0;
  const monthly = 0;
  const yearly = monthly * 12;

  return (
    <Card variant="elevated" className="glass-card glow-hover p-5 md:p-6 flex flex-col" data-testid="assinaturas-resumo-card">
      <div className="flex items-start justify-between gap-3 mb-4">
        <div>
          <span className="text-caption font-semibold uppercase text-brand-purple/80" style={{ letterSpacing: "0.12em" }}>
            Assinaturas
          </span>
          <p className="text-micro text-foreground-subtle mt-0.5">
            {count} ativ{count === 1 ? "a" : "as"} · {fmtBRL(monthly)}/mês
          </p>
        </div>
        <div className="text-right">
          <p className="text-micro text-foreground-subtle uppercase" style={{ letterSpacing: "0.08em" }}>
            Custo anual
          </p>
          <p className="text-h3 font-bold tabular-nums text-foreground">
            {fmtBRL(yearly)}
          </p>
        </div>
      </div>

      <div className="flex-1 flex flex-col items-center justify-center py-4 text-center">
        <div className="w-12 h-12 rounded-full bg-brand-purple/10 flex items-center justify-center mb-3">
          <PartyPopper className="w-5 h-5 text-brand-purple" aria-hidden="true" />
        </div>
        <p className="text-sm font-medium text-foreground">Nenhuma assinatura detectada</p>
        <p className="text-caption text-foreground-muted mt-1 max-w-xs">
          Detecção automática chega na sessão FIN-4.
        </p>
      </div>

      <div className="mt-4 pt-3 border-t border-subtle">
        <button
          type="button"
          onClick={onSeeAll}
          className="inline-flex items-center gap-1 text-caption text-brand-cyan hover:text-brand-cyan/80 transition-colors"
          data-testid="assinaturas-see-all"
        >
          Ver todas
          <ChevronRight className="w-3.5 h-3.5" />
        </button>
      </div>
    </Card>
  );
}
